import {DcpEntryGroup, TypeValuePair} from '@dcp/configurator';
import {Order} from '@spartacus/order/root';

export interface DcpOrder extends Order {
  data?: TypeValuePair[];
  entryGroups?: DcpEntryGroup[];
  purchaseOrderNumber?: string;
}

export enum PaymentModeCode {
  INVOICE = 'INVOICE',
}

export interface PaymentMode {
  code: PaymentModeCode;
  description: string;
  name: string;
}

export interface PaymentModes {
  paymentModes: PaymentMode[];
}

export enum PaymentTypeCode {
  ACCOUNT = 'ACCOUNT',
  CARD = 'CARD',
}

export enum PaymentTypeAction {
  ADD_CARD = 'addNewCard',
}
